import posthog from 'posthog-js'
import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { signOut } from '@/lib/auth-client'
import { clearTabOrganization } from '@/lib/tab-organization'

export function useLogout() {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const logout = async () => {
    try {
      posthog.reset()
      queryClient.clear()
      await signOut()
    } catch (error) {
      console.error('Error during logout:', error)
    } finally {
      clearTabOrganization()
      navigate('/login')
    }
  }

  return { logout }
}
